<script lang="ts" setup>
import type { CircleOption } from '@app/types/ui/circular-progress/interfaces'

import { useCircleProgress } from '@hooks/assessments/circular-progress.hook'

defineOptions({
  name: 'BlockCircularProgress',
})

const props = defineProps<{
  options: CircleOption
}>()

const emit = defineEmits<{
  'click:finished': []
}>()

const setFinished = (): void => {
  emit('click:finished')
}

const {
  displayValue,
  circumference,
  radius,
  center,
  dashOffset,
  currentTitle,
  currentText,
} = useCircleProgress({
  setFinished,
  size: props.options.size,
  stops: props.options.stops,
  speed: props.options.speed,
  pauseDuration: props.options.pauseDuration,
  stroke: props.options.stroke,
})

</script>
<template>
  <div class="circle-progress">
    <div class="circle-progress__box">
      <svg
        class="circle-progress__ring"
        :width="options.size"
        :height="options.size"
      >
        <circle
          class="circle-progress__ring-bg"
          :stroke-width="options.stroke"
          :r="radius"
          :cx="center"
          :cy="center"
        />
        <circle
          class="circle-progress__ring-progress"
          :stroke-width="options.stroke"
          :r="radius"
          :cx="center"
          :cy="center"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="dashOffset"
        />
      </svg>
      <h5 class="circle-progress__percent circle-progress__title-xl btly-text-title-xl xl:btly-text-heading-s">
        {{ Math.round(displayValue) }}%
      </h5>
    </div>
    <div class="circle-progress__text">
      <div
        v-if="currentTitle"
        class="circle-progress__title circle-progress__title-l btly-text-title-l xl:btly-text-heading-s"
      >
        {{ currentTitle }}
      </div>
      <div
        v-if="currentText"
        class="circle-progress__text circle-progress__body-m btly-text-body-m"
      >
        {{ currentText }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/Assessment/BlockCircularProgress.scss" />
